import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    @Input('isInverted') isInverted: boolean = false

    year: any = ''

    constructor() {
        this.year = (new Date()).getFullYear()
    }

    ngOnInit(): void {
    }

}
